import { useState, useEffect } from "react";
import axios from "axios";
import { FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HowItWorks = () => {
  const [sections, setSections] = useState([]);
  const [acceptedAt, setAcceptedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/customer/terms`);
        setSections(res.data?.sections || []);
        setAcceptedAt(res.data?.terms_accepted_at || null);
      } catch (e) {
        console.error("Failed to load How it Works:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#f4cc1e]"></div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <div className="flex items-center gap-3">
        <FileText size={24} className="text-[#091c3c]" />
        <h1 className="text-2xl font-bold text-[#091c3c] font-['Chivo']">How it Works</h1>
      </div>
      {acceptedAt && (
        <p className="text-xs font-semibold text-[#091c3c]/80">
          Accepted on{" "}
          {new Date(acceptedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
        </p>
      )}
      {sections.map((s) => (
        <div key={s.id} className="bg-[#091c3c] border border-[#1a3a6a] rounded-xl shadow-lg p-5 sm:p-6">
          {s.heading && <h2 className="text-lg font-semibold text-white mb-2">{s.heading}</h2>}
          <pre className="whitespace-pre-wrap break-words font-sans text-sm sm:text-[15px] leading-relaxed text-white/90">{s.body}</pre>
        </div>
      ))}
    </div>
  );
};

export default HowItWorks;
